import { login, logout } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
// import storage from '@/utils/storage'

const user = {
  state: {
  },

  mutations: {
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {          
          if(res.code===200){      
            const tokenStr = res.userinfo
            setToken(tokenStr)
            resolve(res)
          }else{
            setToken("")
            reject(res.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut() {
      return new Promise((resolve, reject) => {
        removeToken()
        resolve()
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js